"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import React, { useMemo } from "react";
import { useSidePanel } from "@components/common/containers/side-panel/side-panel-provider";
import { getArrayElementByCalculateHashIndex } from "@lib/common";
import { SidePanelTabsProps } from "./types";

/**
 * Background colors for bookmarks (cycles through a pattern)
 */
const BOOKMARK_COLORS = ["border-r-indigo-500", "border-r-green-500", "border-r-amber-500", "border-r-blue-500", "border-r-purple-500", "border-r-orange-500"];

/**
 * Vertical bookmark navigation component for switching between multiple open panels
 * Renders book-like tabs positioned to the left of the visible panel
 */
export const SidePanelTabs: React.FC<SidePanelTabsProps> = t0 => {
  const $ = _c(15);
  const {
    dontRenderOnePanel
  } = t0;
  const {
    activePanels,
    topPanelId,
    switchToPanel,
    closeAllPanels
  } = useSidePanel();
  let t1;
  if ($[0] !== activePanels) {
    t1 = Array.from(activePanels.values()).sort(_temp);
    $[0] = activePanels;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortedPanels = t1;
  if (dontRenderOnePanel && sortedPanels.length <= 1) {
    return null;
  }
  let t2;
  if ($[2] !== sortedPanels || $[3] !== switchToPanel || $[4] !== topPanelId) {
    let t3;
    if ($[6] !== switchToPanel || $[7] !== topPanelId) {
      t3 = panel => {
        const isActive = panel.id === topPanelId;
        const borderColor = getArrayElementByCalculateHashIndex(panel.id, BOOKMARK_COLORS) as string;
        return <button key={panel.id} role="tab" aria-selected={isActive} aria-label={panel.title} onClick={() => switchToPanel(panel.id)} disabled={isActive} className={cn("h-48 w-12 border-r-4 bg-sidebar", "rotate-180 text-lg tracking-widest whitespace-nowrap uppercase", "transition-opacity duration-300", borderColor, isActive ? "shadow-lg" : "text-muted-foreground brightness-75 dark:brightness-50")} style={{
          writingMode: "vertical-rl"
        }}>{panel.bookmarkLabel}</button>;
      };
      $[6] = switchToPanel;
      $[7] = topPanelId;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = sortedPanels.map(t3);
    $[2] = sortedPanels;
    $[3] = switchToPanel;
    $[4] = topPanelId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== closeAllPanels || $[10] !== sortedPanels.length) {
    t3 = sortedPanels.length > 1 && <button key="close-all" role="tab" aria-selected={false} aria-label="Close all" onClick={closeAllPanels} className={cn("h-12 w-12 border-r-4 bg-sidebar", "rotate-180 text-lg tracking-widest whitespace-nowrap uppercase", "transition-opacity duration-300", getArrayElementByCalculateHashIndex("close-all", BOOKMARK_COLORS) as string, "text-muted-foreground brightness-75 dark:brightness-50")} style={{
      writingMode: "vertical-rl"
    }}>x</button>;
    $[9] = closeAllPanels;
    $[10] = sortedPanels.length;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div role="tablist" aria-orientation="vertical" className="absolute top-0 right-full z-10 flex h-screen flex-col items-center gap-2 border-r pt-3">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
function _temp(a, b) {
  return a.index - b.index;
}